export default {
    methods: {
        redirectToSurveyPeriod(period_id, org_id) {
            if (org_id === undefined) {
                this.get('super-admin/survey-periods/'+period_id+'/period').then((response) => {
                    org_id = response.body.data.organization_id;
                    this.$router.push('/admin/organization-survey/' + org_id + '/' + period_id);
                }).catch((error) => {
                    console.error(error);
                });

                return;
            }

            this.$router.push('/admin/organization-survey/' + org_id + '/' + period_id);
        },

        separateByComma() {
            this.emailsString = this.emailsString.replace(/\n/g, ",");
        },

        handleEmailsString(emailsString = this.emailsString) {
            const emails = emailsString.split(",").filter(email => email !== '');
            this.$emit('addEmailsViaTextarea', emails)
            this.closeOpenModal();
        },

        async getLanguages($http = this.$http) {
            try {
                return await $http.get(`${window.api_endpoint}/super-admin/languages/list`).then(response => response.data.data);
            } catch (error) {
                return error;
            }
        },

        reformatSurveyPeriodStatus(status) {
            switch(status) {
                case "finished":
                    return "paused"
                case "archived":
                    return "finished"
                default:
                    return status;
            }
        },

        getCustomTagShorthand(addedTags) {
            const tags = {
                "EdurioUnlimited": "EU",
                "EdurioHR": "HR",
            }
            const tagKey = addedTags
                .filter(t => Object.keys(tags).includes(t.name))
                .map(t => t.name)[0] || false

            return tagKey && tags[tagKey]
        }
    }
}